var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A3365;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.55,33.31c8.86-0.04,17.49,1.14,25.58,4.97c1.91,0.91,3.78,2.09,5.35,3.51c3.87,3.49,3.59,8.06-0.46,11.36 c-3.71,3.03-8.05,4.7-12.61,5.82c-13.48,3.32-26.89,3.21-40.06-1.41c-2.92-1.02-5.78-2.61-8.23-4.5 c-4.64-3.58-4.28-8.65,0.45-12.19c4.19-3.14,9-4.89,14.03-5.86c5.24-1.01,10.59-1.46,15.89-2.16 C38.5,33.01,38.52,33.16,38.55,33.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.73,27.54c-11.62-0.3-20.62-0.91-29.12-4.46c-1.83-0.77-3.61-1.85-5.15-3.11 c-2.76-2.26-2.72-5.07-0.07-7.43c3.26-2.91,7.31-4.24,11.44-5.18c13.95-3.18,27.94-3.26,41.8,0.41c3.35,0.89,6.62,2.52,9.56,4.38 c3.53,2.24,3.41,5.67,0.1,8.24c-4.01,3.11-8.76,4.52-13.62,5.33C72.88,26.69,67.03,27.16,63.73,27.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.03,58.35c0,3.37,0.31,6.54-0.14,9.6c-0.2,1.36-1.72,2.76-2.98,3.68c-3.96,2.89-8.67,4.03-13.39,4.92 c-11.35,2.15-22.72,2.09-34.06-0.01c-4.41-0.82-8.71-2.05-12.62-4.39c-2.71-1.63-4.32-3.72-4.02-7.09c0.2-2.18,0.04-4.39,0.04-6.86 c10.28,6.97,21.68,8.73,33.51,8.75C50.21,66.98,61.63,65.28,72.03,58.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.86,76.71c21.08,9.74,46.22,9.78,66.94,0.2c1.91,4.39,0.35,9.73-3.63,12.15c-4.33,2.64-9.18,3.78-14.1,4.64 c-8.89,1.56-17.85,1.63-26.78,0.62c-6.53-0.74-12.98-1.95-18.72-5.48C6,87.28,4.49,85.21,4.83,82.01 C5.01,80.32,4.86,78.61,4.86,76.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.75,25.92c0,2.73,0.36,5.25-0.13,7.6c-0.32,1.54-1.61,3.18-2.92,4.16c-3.98,2.97-8.73,4.1-13.54,4.94 c-0.39,0.07-1.09-0.17-1.23-0.47c-1.85-3.9-5.08-6.35-8.66-8.46c-0.08-0.05-0.09-0.21-0.25-0.61 C77.33,32.32,86.38,30.75,94.75,25.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.17,60.01c0-3.97-0.06-7.18,0.07-10.38c0.02-0.43,0.93-1.07,1.51-1.19c5.17-1.05,10.14-2.61,14.64-5.45 c1.97,5.59,0.42,10.32-4.78,12.9C86.16,57.59,82.33,58.54,78.17,60.01z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.860185918d466a8f122bc60c63c0e2b3.svg";
export { ForwardRef as ReactComponent };